import { render, staticRenderFns } from "./EditSchoolYear.vue?vue&type=template&id=7d9373c8&"
import script from "./EditSchoolYear.vue?vue&type=script&lang=js&"
export * from "./EditSchoolYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports